module.exports = __webpack_public_path__ + "static/credit-cards-df3e2638821751b99776d03e232e6936.svg";